const supportsVT    = 'startViewTransition' in document;
const supportsTypes = supportsVT && 'types' in ViewTransition.prototype;


// — Product form —————————————————————————————————————————————————————————————

function initProduct(scope) {
  const root = scope || document;
  const form = root.querySelector('[action*="/cart/add"]');
  if (!form) return;

  const variantInput    = form.querySelector('input[name="id"]');
  const variants        = window.productVariants || [];
  const atcBtn          = form.querySelector('[data-atc-btn]');
  const unavailableBtn  = form.querySelector('[data-unavailable-btn]');
  const hideBIS         = !!unavailableBtn;
  const requiredSelects = [...form.querySelectorAll('fancy-select[data-required]')];
  const hasRequired     = requiredSelects.length > 0;

  // — ATC label —

  const allVariantsSoldOut = variants.length > 0 && variants.every(v => !v.available);

  const updateAtcLabel = () => {
    if (!atcBtn) return;
    const unselected = hasRequired && requiredSelects.some(fs => !fs.value);
    if (allVariantsSoldOut) {
      atcBtn.textContent = window.themeT?.['products.form.sold_out'] ?? 'Sold Out';
      atcBtn.classList.remove('hidden');
      atcBtn.classList.add('cursor-not-allowed!');
      atcBtn.disabled = true;
    } else {
      atcBtn.classList.remove('cursor-not-allowed!');
      atcBtn.disabled = false;
      atcBtn.textContent = unselected
        ? (window.productIsGiftCard
            ? (window.themeT?.['products.form.select_amount'] ?? 'Select an Amount')
            : (window.themeT?.['products.form.select_size']   ?? 'Select a Size'))
        : (window.themeT?.['products.form.add_to_bag'] ?? 'Add to Bag');
    }
    atcBtn.classList.toggle('disabled', unselected && !allVariantsSoldOut);
  };

  // — Attentive BIS —

  const attnWrap = form.querySelector('[data-attn-wrap]');

  // — ATC / BIS state —

  const updateAtcState = (variant) => {
    if (!atcBtn) return;

    const unselected = hasRequired && requiredSelects.some(fs => !fs.value);
    if (unselected) {
      atcBtn.classList.remove('hidden');
      unavailableBtn?.classList.add('hidden');
      attnWrap?.classList.add('hidden');
      return;
    }

    if (!variant) return;
    const soldOut = !variant.available;

    if (hideBIS) {
      atcBtn.classList.toggle('hidden', soldOut);
      unavailableBtn.classList.toggle('hidden', !soldOut);
      return;
    }

    atcBtn.classList.toggle('hidden', soldOut);
    attnWrap?.classList.toggle('hidden', !soldOut);
  };

  // — Variant matching —

  const updateVariant = () => {
    updateAtcLabel();
    const selectedOptions = [...form.querySelectorAll('input[id^="Option-"]')].map(i => i.value);
    const match = variants.find(({ options }) =>
      options.every((opt, i) => opt === selectedOptions[i])
    );
    if (match) {
      variantInput.value = match.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
      updateAtcState(match);
      if (!scope) syncAnalyticsMeta({ variantId: match.id });
      attnProductView(attnWrap, match);
    } else {
      updateAtcState(null);
    }
  };

  // — Event listeners —

  form.querySelectorAll('select').forEach(s =>
    s.addEventListener('change', updateVariant)
  );

  form.querySelectorAll('fancy-select').forEach(fs =>
    fs.addEventListener('change', e => {
      const hidden = form.querySelector(`#${fs.dataset.for}`);
      if (hidden) hidden.value = e.detail.value;
      if (fs.dataset.required !== undefined) {
        const err = fs.nextElementSibling;
        const hasVal = !!e.detail.value;
        err?.classList.contains('fs-error') && err.classList.toggle('hidden', hasVal);
        fs.classList.toggle('fs-error-state', !hasVal);
      }
      updateAtcLabel();
      updateVariant();
    })
  );

  form.addEventListener('submit', e => {
    let valid = true;
    form.querySelectorAll('fancy-select[data-required]').forEach(fs => {
      if (!fs.value) {
        valid = false;
        const err = fs.nextElementSibling;
        err?.classList.contains('fs-error') && err.classList.remove('hidden');
        fs.classList.add('fs-error-state');
      }
    });
    if (!valid) e.preventDefault();
  });

  // — Init —

  updateAtcLabel();
  const initialVariant = variants.find(v => v.id === parseInt(variantInput.value));
  if (initialVariant) {
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateAtcState(initialVariant);
  }

  // — Review count —
  const reviewWidget = root.querySelector('.jdgm-widget');
  const reviewCount  = root.querySelector('[data-reviews-count]');
  if (reviewWidget && reviewCount) {
    const syncCount = () => {
      const text  = reviewWidget.querySelector('.jdgm-prev-badge__text')?.textContent ?? '';
      const match = text.match(/\d[\d,]*/);
      reviewCount.textContent = match ? `(${match[0]})` : '';
    };
    syncCount();
    new MutationObserver(syncCount).observe(reviewWidget, { childList: true, subtree: true, characterData: true });
  }
}

// Attentive reads product/variant from here — keep in sync after swaps
function syncAnalyticsMeta({ productId, variants, variantId } = {}) {
  const meta = window.ShopifyAnalytics?.meta;
  if (!meta) return;

  if (productId && variants) {
    meta.product = {
      id:       Number(productId),
      gid:      `gid://shopify/Product/${productId}`,
      variants: variants.map(v => ({ id: v.id, price: v.price, name: v.name, public_title: v.public_title, sku: v.sku })),
    };
    if (meta.page) meta.page.resourceId = Number(productId);
  }

  if (variantId) meta.selectedVariantId = String(variantId);
}

// Re-runs Attentive's waitlist check for the current variant
function attnProductView(wrap, variant) {
  if (!wrap || !variant) return;

  const payload = {
    items: [{
      productId:        String(wrap.dataset.productId),
      productVariantId: String(variant.id),
      name:             variant.name,
      price: {
        value:    (variant.price / 100).toFixed(2),
        currency: window.Shopify?.currency?.active,
      },
    }],
  };

  const send = () => {
    if (!window.attentive?.analytics?.productView) return false;
    window.attentive.analytics.productView(payload);
    return true;
  };
  if (send()) return;

  // Tag loads async — poll for up to 3s
  let attempts = 0;
  const interval = setInterval(() => {
    if (send() || ++attempts >= 30) clearInterval(interval);
  }, 100);
}


// — Navigation selects ————————————————————————————————————————————————————————

function initNavigationSelects() {
  document.querySelectorAll('fancy-select[data-navigate]').forEach(fs =>
    fs.addEventListener('change', e => window.navigateTo(e.detail.value))
  );
}


// — SPA navigation ————————————————————————————————————————————————————————————

let _attnTrigger = null;

window.navigateTo = async function navigateTo(url) {
  const scrollY       = window.scrollY;
  const lockedHeight  = document.querySelector('main')?.offsetHeight;
  const preservedReviews = document.querySelector('#judgeme_product_reviews')?.closest('[id^="shopify-section-"]');

  const skeletonSelectors = ['[data-pdp-load]'];
  const skeletonHeights   = {};
  skeletonSelectors.forEach(sel => {
    const el = document.querySelector(sel);
    if (el) skeletonHeights[sel] = el.offsetHeight;
  });

  const html = await (_swatchCache.get(url) ?? fetch(url).then(r => r.text()));
  _swatchCache.delete(url);

  const doc      = new DOMParser().parseFromString(html, 'text/html');
  const newMain  = doc.querySelector('main');

  // Kick off image preloads in background — don't block the transition
  newMain.querySelectorAll('option[data-image]').forEach(o => { new Image().src = o.dataset.image; });

  newMain.dataset.loading = '';
  skeletonSelectors.forEach(sel => {
    const el = newMain.querySelector(sel);
    if (el && skeletonHeights[sel]) el.style.minHeight = skeletonHeights[sel] + 'px';
  });

  const update = async () => {
    if (lockedHeight) newMain.style.minHeight = lockedHeight + 'px';

    document.documentElement.style.overflow = 'hidden';

    _attnTrigger = document.getElementById('attn-waitlist-trigger') || _attnTrigger;
    document.querySelector('main').replaceWith(newMain);
    const newAttnTrigger = newMain.querySelector('#attn-waitlist-trigger');
    if (_attnTrigger && newAttnTrigger) newAttnTrigger.replaceWith(_attnTrigger);

    document.title = doc.title;
    history.pushState({}, doc.title, url);
    _lastPathname = window.location.pathname;
    window.scrollTo({ top: scrollY, behavior: 'instant' });
    document.documentElement.style.overflow = '';

    // Re-execute inline scripts from the new page (skip non-JS types)
    newMain.querySelectorAll('script:not([src])').forEach(s => {
      const type = s.type.trim().toLowerCase();
      if (type && type !== 'text/javascript') return;
      const script = document.createElement('script');
      script.textContent = s.textContent;
      document.head.appendChild(script).remove();
    });

    initProduct();
    initNavigationSelects();
    initFavoriteTeam();
    initFavoriteDriver();
    prefetchSiblings();

    const variantId = Number(newMain.querySelector('[action*="/cart/add"] input[name="id"]')?.value);
    syncAnalyticsMeta({ productId: window.productId, variants: window.productVariants, variantId });
    attnProductView(
      newMain.querySelector('[data-attn-wrap]'),
      (window.productVariants || []).find(v => v.id === variantId)
    );

  };

  if (supportsVT) {
    const transition = supportsTypes
      ? document.startViewTransition({ update, types: ['update'] })
      : document.startViewTransition(update);
    await transition.finished;
  } else {
    await update();
  }

  if (preservedReviews) {
    const newReviews = document.querySelector('#judgeme_product_reviews')?.closest('[id^="shopify-section-"]');
    if (newReviews) newReviews.replaceWith(preservedReviews);
  }

  if (newMain) {
    newMain.style.minHeight = '';
    setTimeout(() => {
      newMain.removeAttribute('data-loading');
      skeletonSelectors.forEach(sel => {
        const el = newMain.querySelector(sel);
        if (el) el.style.minHeight = '';
      });
    }, 800);
  }
};

// Intercept swatch/team selector link clicks only (not product cards — handled by product-card.js)

const _swatchCache = new Map();

window._warmSwatch = function _warmSwatch(href) {
  if (!href || _swatchCache.has(href)) return;
  _swatchCache.set(href, fetch(href).then(r => r.text()));
};

document.addEventListener('mouseover', e => {
  const link = e.target.closest('a[data-swatch][href]');
  if (link && !link.closest('product-card') && !link.closest('quick-buy')) {
    window._warmSwatch(link.href);
    return;
  }
  const opt = e.target.closest('fancy-select[data-navigate] [role="option"]');
  if (opt?.dataset.value) window._warmSwatch(opt.dataset.value);
}, { passive: true });

document.addEventListener('click', e => {
  const link = e.target.closest('a[data-swatch][href]');
  if (!link) return;
  if (link.closest('product-card')) return;
  if (link.closest('quick-buy')) return;
  const url = new URL(link.href);
  if (url.origin !== window.location.origin) return;
  e.preventDefault();
  document.querySelectorAll('a[data-swatch]').forEach(s => {
    s.removeAttribute('aria-current');
    s.classList.remove('ring-2', 'ring-offset-2', 'ring-black');
  });
  link.setAttribute('aria-current', 'true');
  link.classList.add('ring-2', 'ring-offset-2', 'ring-black');
  window.navigateTo(link.href);
});

let _lastPathname = window.location.pathname;
window.addEventListener('popstate', () => {
  if (window.location.pathname === _lastPathname) return;
  _lastPathname = window.location.pathname;
  window.navigateTo(window.location.href);
});

// — Sibling prefetch ——————————————————————————————————————————————————————————

function prefetchSiblings() {
  const urls = new Set();

  document.querySelectorAll('a[data-swatch][href]').forEach(a => {
    try { urls.add(new URL(a.href, location.origin).pathname); } catch {}
  });

  document.querySelectorAll('fancy-select[data-navigate] option[value]').forEach(o => {
    if (o.value) try { urls.add(new URL(o.value, location.origin).pathname); } catch {}
  });

  urls.forEach(path => {
    if (path === location.pathname) return;
    if (document.querySelector(`link[rel="prefetch"][href="${path}"]`)) return;
    const link = document.createElement('link');
    link.rel  = 'prefetch';
    link.href = path;
    link.as   = 'document';
    document.head.appendChild(link);
  });
}

prefetchSiblings();

// — Favorite team —————————————————————————————————————————————————————————————

function setHeartState(btn, selected) {
  btn.classList.toggle('selected', selected);
  btn.setAttribute('aria-pressed', String(selected));
  btn.querySelector('.js-pdp-ft-empty')?.classList.toggle('hidden', selected);
  btn.querySelector('.js-pdp-ft-filled')?.classList.toggle('hidden', !selected);
}

function initFavoriteTeam() {
  document.querySelectorAll('.js-pdp-ft').forEach(btn => {
    btn.addEventListener('click', () => {
      const cf = btn.closest('.js-cf');
      if (cf?.classList.contains('js-no-customer')) {
        const accountId = document.querySelector('[data-modal-content^="account-drawer-"]')?.dataset.modalContent;
        const modal = document.querySelector('custom-modal');
        if (accountId && modal) {
          modal.open(accountId);
          setTimeout(() => document.querySelector('[data-account-target="register"]')?.click(), 0);
        }
        return;
      }
      const team       = btn.dataset.team;
      const league     = btn.dataset.league || '';
      const isSelected = btn.classList.contains('selected');
      setHeartState(btn, !isSelected);
      isSelected ? removeFavoriteTeam(team) : addFavoriteTeam(team, league);
    });
  });
}

function addFavoriteTeam(team, league) {
  window.CF?.customerReady(() => {
    let teams = [...(CF.customer.get('favorite_teams_list') || [])];
    const key = `${team}|${league}`.replace(/ /g, '-').toUpperCase();
    if (!teams.includes(key)) teams.push(key);
    CF.customer.set('favorite_teams_list', teams);
    saveCFData();
    CF.customer.addTag(`fav_team-${team.replaceAll(' ', '-')}`);
    CF.customer.save({ formId: window.customer_fields?.account_preferences });
  });
}

function removeFavoriteTeam(team) {
  window.CF?.customerReady(() => {
    const handle = team.toLowerCase().replace(/ /g, '-');
    let teams = (CF.customer.get('favorite_teams_list') || []).filter(t =>
      t.split('|')[0].toLowerCase() !== handle
    );
    CF.customer.set('favorite_teams_list', teams);
    saveCFData();
    CF.customer.removeTag(`fav_team-${team.replaceAll(' ', '-')}`);
    CF.customer.save({ formId: window.customer_fields?.account_preferences });
  });
}

function initFavoriteDriver() {
  document.querySelectorAll('.js-pdp-fd').forEach(btn => {
    btn.addEventListener('click', () => {
      const cf = btn.closest('.js-cf');
      if (cf?.classList.contains('js-no-customer')) {
        const accountId = document.querySelector('[data-modal-content^="account-drawer-"]')?.dataset.modalContent;
        const modal = document.querySelector('custom-modal');
        if (accountId && modal) {
          modal.open(accountId);
          setTimeout(() => document.querySelector('[data-account-target="register"]')?.click(), 0);
        }
        return;
      }
      const driver     = btn.dataset.driver;
      const isSelected = btn.classList.contains('selected');
      setHeartState(btn, !isSelected);
      isSelected ? removeFavoriteDriver(driver) : addFavoriteDriver(driver);
    });
  });
}

function addFavoriteDriver(driver) {
  window.CF?.customerReady(() => {
    let drivers = [...(CF.customer.get('favorite_drivers') || [])];
    const key = driver.replace(/ /g, '-').toUpperCase();
    if (!drivers.includes(key)) drivers.push(key);
    CF.customer.set('favorite_drivers', drivers);
    saveCFData();
    CF.customer.addTag(`fav_driver-${driver.replaceAll(' ', '-')}`);
    CF.customer.save({ formId: window.customer_fields?.account_preferences });
  });
}

function removeFavoriteDriver(driver) {
  window.CF?.customerReady(() => {
    const handle = driver.toLowerCase().replace(/ /g, '-');
    let drivers = (CF.customer.get('favorite_drivers') || []).filter(d =>
      d.toLowerCase() !== handle
    );
    CF.customer.set('favorite_drivers', drivers);
    saveCFData();
    CF.customer.removeTag(`fav_driver-${driver.replaceAll(' ', '-')}`);
    CF.customer.save({ formId: window.customer_fields?.account_preferences });
  });
}

function saveCFData() {
  window.CF?.customer?.save().catch(err => console.error('CF save error', err));
}

// — Image zoom ————————————————————————————————————————————————————————————————

function updateZoomCounter(productId, n) {
  const el = document.querySelector(`[data-zoom-counter="${productId}"]`);
  if (!el) return;
  const total = el.dataset.zoomTotal || '?';
  el.textContent = `Image ${n} of ${total}`;
}

function initImageZoom() {
  // Preload hovered image before click lands
  document.addEventListener('pointerover', e => {
    const trigger = e.target.closest('[data-zoom-trigger][data-zoom-src]');
    if (!trigger || trigger._zoomPreloaded) return;
    trigger._zoomPreloaded = true;
    new Image().src = trigger.dataset.zoomSrc;
  }, { passive: true });

  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-zoom-trigger][data-product-id]');
    if (!trigger) return;
    const { productId, zoomIndex } = trigger.dataset;
    const idx = parseInt(zoomIndex || '0', 10);
    window.dispatchEvent(new CustomEvent('modal:openById', { detail: `image-zoom-${productId}` }));
    setTimeout(() => {
      const sc = document.getElementById(`image-zoom-swiper-${productId}`);
      if (sc?.swiper) {
        sc.swiper.slideTo(idx, 0);
        updateZoomCounter(productId, sc.swiper.realIndex + 1);
      }
    }, 20);
  });

  document.addEventListener('swiperslidechange', e => {
    const sc = e.target;
    if (!sc?.id?.startsWith('image-zoom-swiper-')) return;
    const productId = sc.id.replace('image-zoom-swiper-', '');
    updateZoomCounter(productId, sc.swiper.realIndex + 1);
  });
}


// — Bootstrap —————————————————————————————————————————————————————————————————

initProduct();
initNavigationSelects();
initFavoriteTeam();
initFavoriteDriver();
initImageZoom();
